import React from 'react';

class HostApps extends React.Component {
  render() {
    let hostInfo = this.props.hostInfo;

    return (
      <div
        className='pure-g pure-p pure-u-1'
        style={{ position: 'relative', backgroundColor: 'white', paddingTop: 30, marginBottom: 10 }}
      >
        <div style={{ position: 'absolute', top: 0, left: 0 }}>
          <div className='box-info'>packages</div>
        </div>

        {hostInfo.systemInfo && (
          <div className='info-card pure-u-24-24'>
            <span>System Info:</span>
            {hostInfo.systemInfo}
          </div>
        )}

        {renderAppBlock(hostInfo, 'java', 'Java')}
        {renderAppBlock(hostInfo, 'jdk7', 'JDK 7')}
        {renderAppBlock(hostInfo, 'jdk8', 'JDK 8')}
        {renderAppBlock(hostInfo, 'tomcat', 'Tomcat')}
        {renderAppBlock(hostInfo, 'apache2', 'Apache2')}
        {renderAppBlock(hostInfo, 'nodejs', 'node.js')}
        {renderAppBlock(hostInfo, 'mariadb5', 'MariaDB')}
        {renderAppBlock(hostInfo, 'mariadb10', 'MariaDB')}
        {renderAppBlock(hostInfo, 'google-chrome-stable', 'Google Chrome')}
        {renderAppBlock(hostInfo, 'chromium-browser', 'Chromium Browser')}
        {renderAppBlock(hostInfo, 'openssh-server', 'OpenSSH Server')}
        {renderAppBlock(hostInfo, 'vino', 'Vino VNC Server')}
        {renderAppBlock(hostInfo, 'motion', 'Motion')}
        {renderAppBlock(hostInfo, 'bash', 'Bash Shell')}
        {renderAppBlock(hostInfo, 'fish', 'Fish Shell')}
        {renderAppBlock(hostInfo, 'python', 'Python')}
      </div>
    );
  }
}

function renderAppBlock(hostInfo = {}, pkgName, label) {
  let basicInfo = hostInfo.basicInfo;
  let serverInfo = hostInfo.serverInfo;
  let kioskInfo = hostInfo.kioskInfo;
  if (basicInfo[pkgName] && basicInfo[pkgName].version) {
    return (
      <div className='info-card pure-u-6-24'>
        <span>{label || basicInfo[pkgName].name || pkgName}:</span>
        {basicInfo[pkgName].version}
      </div>
    );
  }
  if (serverInfo[pkgName] && serverInfo[pkgName].version) {
    return (
      <div className='info-card pure-u-6-24'>
        <span>{label || serverInfo[pkgName].name || pkgName}:</span>
        {serverInfo[pkgName].version}
      </div>
    );
  }
  if (kioskInfo[pkgName] && kioskInfo[pkgName].version) {
    return (
      <div className='info-card pure-u-6-24'>
        <span>{label || kioskInfo[pkgName].name || pkgName}:</span>
        {kioskInfo[pkgName].version}
      </div>
    );
  }
  return null;
}

export default HostApps;



// WEBPACK FOOTER //
// ./src/components/HostApps.js